<template>
  <div class="widget-item commercial-tenants" :id="widget.object.wid" :style="style">
    <CommercialTenantsViewer :widgetData="widget.object" />
  </div>
</template>

<script>
  import CommercialTenantsViewer from '@/components/apps/commercialTenants/CommercialTenantsViewer.vue';

  import templateWidget from '@/components/widgets/templates/mixins/templateWidget';
  import { simpleTypeMixin } from '@/helpers';
  import { getRBGAColor } from '@/helpers/utils';

  export default {
    name: 'CommercialTenantsWidget',

    components: { CommercialTenantsViewer },

    mixins: [simpleTypeMixin, templateWidget],

    props: {
      widget: {
        type: Object,
        required: true,
      },
    },

    computed: {
      style() {
        return Object.assign({}, this.defaultStyling(this.widget), {
          overflow: 'hidden',
          backgroundColor: getRBGAColor(
            this.widget.object.backgroundColor,
            this.widget.object.opacity / 100,
          ),
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .widget-item {
    position: absolute;
    overflow: hidden;
  }
</style>
